import React, { useEffect, useState, Fragment, useContext } from "react";
import Layout from "components/sales/layoutChange/layout";
import TableSection from "components/sales/tableSection/tableSection";
import { ArrowRight, Filter, tick } from "assets/images/imageData";
import localization from "assets/localization/localization";
import { Button,FormGroup } from "react-bootstrap";
import Images from "assets/images/imageData";
import { Link } from "react-router-dom";
import AddPaymentPopup from "components/sales/paymentPortal/addPayment/addPaymentPopup";
import 'components/sales/layoutChange/layout.css';
import './vendorstyle.css';
import ConstantInput from "components/sales/Input/constantInput/constantInput";
import DropDownInput from "components/sales/Input/dropDownInput/dropDownInput";
import { DatePickerInput } from "rc-datepicker";
import FileUpload from "components/sales/fileUpload/fileUpload";
import * as moment from "moment";
import SlidingPane from "react-sliding-pane";
import "react-sliding-pane/dist/react-sliding-pane.css";
import ErrModalPop from 'components/sales/modal/errorModal';
import parse from 'html-react-parser';
import ModalPop from "components/sales/modal/modal";
import { BaseUrl } from 'contexts/baseUrl/baseUrl';
import DivLayout from 'components/sales/divLayout/divLayout';
import DocumentView from 'components/sales/downloadDocView/documentView';


const PaymentDetails = ({
  vendorPaymentDetails,
  dataList,
  savePaymentRequest,
  match,
  history,
}) => {
  const [teamId, setTeamId] = useState();
  const { baseUrl } = useContext(BaseUrl);
  const [isFocus1, setIsFous1] = useState(true);
  const [departmentId, setDepartmentId] = useState();
  const [showFilter, setShowFilter] = useState(false);
  const [isRoleId, setIsRoleId] = useState(null);
  const [isLoading, setIsLoading] = useState(false);
  const [requestAmt, setRequestAmt] = useState('');
  const [pendingAmt, setPendingAmt] = useState(0);
  const [isModal, setIsModal] = useState(false);
  const [saveModal, setSaveModal] = useState(false);
  const [isModalPO, setIsModalPO] = useState(false);
  const [errorMsg, setIsErrorMsg] = useState('');
  const [isErrorModal, setIsErrorModal] = useState(false);
  

  const [state, setState] = useState({
    isPaneOpen: false,
    isPaneOpenLeft: false,
  });
  
  useEffect(() => {
    (async () => {
      const roles = await JSON.parse(localStorage.getItem("roles"));
      roles && setIsRoleId(roles[0].pivot.role_id);
    })();
  }, []);


  useEffect(() => {
    (async () => {
      const team =
        (await JSON.parse(localStorage.getItem("profileDetails"))) &&
        JSON.parse(localStorage.getItem("profileDetails"))[0].team_id;
      const deparment =
        (await JSON.parse(localStorage.getItem("profileDetails"))) &&
        JSON.parse(localStorage.getItem("profileDetails"))[0].department_id;
      setTeamId(team);
      setDepartmentId(deparment);
    })();
  }, []);

  useEffect(() => {
    if (match?.params?.id) {
    
      (async () => {
        setIsLoading(true);
        await vendorPaymentDetails(match?.params?.id);
        setIsLoading(false);
      })();
    
  }
  }, [vendorPaymentDetails]);

  useEffect(() => {
    if(dataList.invoice_data?.total_amount){
      var totalAmt = dataList.invoice_data?.total_amount;
      var reqAmt = dataList.invoice_data?.request_amount;
      var pendingAmt = Number(totalAmt) - Number(reqAmt)
      setPendingAmt(pendingAmt);
    }
  },[dataList]);

  const checkRequestedAmt = (val) => {
    const pendingAmts = Number(pendingAmt);
    if(pendingAmts < Number(val)){
      setIsModal(true);
    }else{
      setRequestAmt(val);
    }
  };

  const handleModalHide = () => {
    // history.push(`${baseUrl}/postSalesListing`);
    setRequestAmt(0);
    setIsModal(false);
  };

  const handleErrorModal = () =>{
    setIsErrorModal(false);
  }

  const submitVendorReq = () =>{
   
    if(pendingAmt && match?.params?.id && requestAmt !=''){
      if(Number(pendingAmt) < Number(requestAmt)){
        setIsModal(true);
        return false;
      }
      (async () => {
        const data = {'request_amt' : requestAmt};
        data['payment_id'] = match?.params?.id;
        const res = await savePaymentRequest(data);
        if (res) {
          console.log(res);
          setSaveModal(true);
        }
      })();
    }else{
      var errMsg = 'Please enter data in required fields!<br/>'; 
        setIsErrorMsg(errMsg);
        setIsErrorModal(true);
        return false;
    }
    
    
  }

  const handleSaveModalHide = () => {
    history.push(`${baseUrl}/vendorPaymentList`);
    setIsModal(false);
  };
  return (
    <Layout
      title={localization.vendorPaymentDetail}
      isLoading={isLoading}
      searchOption={false}
    >
     
    <Fragment>
     <div className="panel-card card border-round">
          <div className="card-header border-primary">
               <span className="vendorHeading">Invoice Details</span>
          </div>
          <div className="card-body">
          <div className="details-listing detail_alignment">
               <DivLayout
                  heading={localization.vendorCode}
                  data={
                    dataList.invoice_data?.vendor_code
                      ? dataList.invoice_data.vendor_code
                      : localization.na
                  }
                />
                <DivLayout
                  heading={localization.vendorName}
                  data={
                    dataList.invoice_data?.name_of_firm
                      ? dataList.invoice_data.name_of_firm
                      : localization.na
                  }
                />
                <DivLayout
                  heading={localization.gstNumberHead}
                  data={
                    dataList.invoice_data?.gst_no
                      ? dataList.invoice_data.gst_no
                      : localization.na
                  }
                />
          </div>
          <hr/>
          {/* <div className="details-listing detail_alignment">
               <DivLayout
                  heading={localization.expense_basis}
                  data={
                    dataList.invoice_data?.expense_basis
                      ? dataList.invoice_data.expense_basis
                      : localization.na
                  }
                />
                { dataList.invoice_data?.expense_basis && dataList.invoice_data.expense_basis === 'PO' ? 
                  <>
                    <DivLayout
                      heading={localization.poNo}
                      data={
                        dataList.invoice_data?.po_number
                          ? dataList.invoice_data.po_number
                          : localization.na
                      }
                    />
                    <DivLayout
                        heading={localization.poAmt}
                        data={
                          dataList.invoice_data?.po_amount
                            ? dataList.invoice_data.po_amount
                            : localization.na
                        }
                      />
                  </>
                : null}
                <DivLayout
                  heading={localization.expense_type}
                  data={
                    dataList.invoice_data?.expense_type
                      ? dataList.invoice_data.expense_type
                      : localization.na
                  }
                />
                <DivLayout
                  heading={localization.createdBy}
                  data={
                    dataList.invoice_data?.createdBy_name
                      ? dataList.invoice_data.createdBy_name
                      : localization.na
                  }
                />
                <DivLayout
                  heading={localization.invDescription}
                  data={
                    dataList.invoice_data?.description
                      ? dataList.invoice_data.description
                      : localization.na
                  }
                />
          </div>
          <hr/> */}
          <div className="details-listing detail_alignment">
               <DivLayout
                  heading={localization.invoiceNo}
                  data={
                    dataList.invoice_data?.invoice_number
                      ? dataList.invoice_data.invoice_number
                      : localization.na
                  }
                />
                <DivLayout
                  heading={localization.invoiceDate}
                  data={
                    dataList.invoice_data?.invoice_date
                      ? dataList.invoice_data.invoice_date
                      : localization.na
                  }
              />
               <div
                  className={'details-list'}
                > 
                <DocumentView
                  title={`Invoice`}
                  attachment={
                    dataList?.invoice_document
                      ? dataList?.invoice_document
                      : localization.na
                  }
                />
                </div>  
                <DivLayout
                  heading={localization.taxableAmt}
                  data={
                    dataList.invoice_data?.taxable_amount
                      ? dataList.invoice_data.taxable_amount
                      : localization.na
                  }
              />
              <DivLayout
                  heading={localization.freightAmt}
                  data={
                    dataList.invoice_data?.freight_amount
                      ? dataList.invoice_data.freight_amount
                      : localization.na
                  }
              />
              <DivLayout
                  heading={localization.otherAmt}
                  data={
                    dataList.invoice_data?.other_charges
                      ? dataList.invoice_data.other_charges
                      : localization.na
                  }
              /> 
              {dataList.invoice_data?.cgst && dataList.invoice_data?.cgst != 0 ? 
              <>
                <DivLayout
                  heading={localization.cgst}
                  data={
                    dataList.invoice_data?.cgst
                      ? dataList.invoice_data.cgst
                      : localization.na
                  }
                  />
                  <DivLayout
                      heading={localization.sgst}
                      data={
                        dataList.invoice_data?.sgst
                          ? dataList.invoice_data.sgst
                          : localization.na
                      }
                  />
              </>
                
              :
              <DivLayout
                  heading={localization.igst}
                  data={
                    dataList.invoice_data?.igst
                      ? dataList.invoice_data.igst
                      : localization.na
                  }
              /> 
              }

                <DivLayout
                  heading={localization.totalAmountIncludeTax}
                  data={
                    dataList.invoice_data?.total_amount
                      ? dataList.invoice_data.total_amount
                      : localization.na
                  }
              /> 
              <DivLayout
                  heading={localization.totalRequestedAmount}
                  data={
                    dataList.invoice_data?.request_amount
                      ? dataList.invoice_data.request_amount
                      : localization.na
                  }
              /> 
              <DivLayout
                  heading={localization.pendingAmt}
                  data={
                    pendingAmt
                      ? pendingAmt
                      : '.'
                  }
              /> 
              
              
          </div>
          <hr/>
          </div>
      </div>
      <div className="panel-card card border-round">
          <div className="card-header border-primary">
               <span className="vendorHeading">Add Request</span>
          </div>
          <div className="card-body">
                  <div className="row">
                    <div className="col-md-4">
                      <ConstantInput
                          label={localization.requestAmt}
                          type="text"
                          value={requestAmt}
                          handleChange={(val) => {
                            checkRequestedAmt(val)
                          }}
                          required
                          isStarRequired={true}
                        
                      />
                    </div>
                    <div className="col-md-4">
                      <Button  onClick={submitVendorReq}>
                        {localization.submitDtl} 
                      </Button>
                    </div>
                  </div>
          </div>
      </div>
      <ModalPop
            title={localization.warning}
            show={isModal}
            handleModalHide={handleModalHide}
            keyboard
          >
            <div className="text-center">
              
                <img src={Images?.alert} alt="" />
             
              <h5>Requested amount should be less than or equal to total amount!</h5>
             
            
            </div>
          </ModalPop>
          <ErrModalPop
            title={localization.error}
            show={isErrorModal}
            handleModalHide={handleErrorModal}
            keyboard
            backdrop
          >
            <div className="text-center">
              {parse(errorMsg)}
            </div>
          </ErrModalPop>
          <ModalPop
            title={localization.success}
            show={saveModal}
            handleModalHide={handleSaveModalHide}
            keyboard
          >
            <div className="text-center">
              
              <div className="success">
              <img src={Images?.tick} alt="" />
            </div>
             
              <h5>Saved !</h5>
             
            
            </div>
          </ModalPop>
    </Fragment>
   </Layout>
  );
};

export default PaymentDetails;
